// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".code {\n    font-family: 'Courier New', Courier, monospace;\n    font-size: small;\n}", "",{"version":3,"sources":["webpack://src/style.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,gBAAgB;AACpB","sourcesContent":[".code {\n    font-family: 'Courier New', Courier, monospace;\n    font-size: small;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
